// extracted by extract-css-chunks-webpack-plugin
module.exports = {"breadcrumbsContainer":"AYhQy","row":"tLI-0","nonDesktop":"zyzr6","crumbListItem":"GRuTd undefined"};